import { confluenceLocalStorageInstance } from '@confluence/storage-manager/entry-points/storageInstance.ts';

import { TWENTY_EIGHT_DAYS_IN_SECONDS } from './time-constants.ts';

export const markDiscoveryExperienceAsSeen = (experienceKey: string): void => {
	confluenceLocalStorageInstance.setItem(experienceKey, true, TWENTY_EIGHT_DAYS_IN_SECONDS);
};
